import React from 'react';
import type { SentimentLabel } from '../lib/api';

interface SentimentBadgeProps {
    sentiment: SentimentLabel;
    score?: number;
}

export const SentimentBadge: React.FC<SentimentBadgeProps> = ({ sentiment, score }) => {
    const getStyles = () => {
        switch (sentiment) {
            case 'positive':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'negative':
                return 'bg-red-100 text-red-800 border-red-200';
            case 'mixed':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const getEmoji = () => {
        switch (sentiment) {
            case 'positive': return '😊';
            case 'negative': return '😞';
            case 'mixed': return '😐';
            default: return '😶';
        }
    };

    return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStyles()}`}>
            <span>{getEmoji()}</span>
            <span className="capitalize">{sentiment}</span>
            {score !== undefined && (
                <span className="opacity-75">({score > 0 ? '+' : ''}{score.toFixed(2)})</span>
            )}
        </span>
    );
};
